module.exports = __webpack_public_path__ + "img/lms-dashboard-33connect.36fc636a.png";